import { useState } from "react";
import Icon from '@mdi/react';
import { mdiShareVariant, mdiQrcode } from '@mdi/js';
import { toggleModal } from '../../utils/uiUtils';
import { QRCode } from 'react-qrcode-logo';
import logo24 from '../../media/logo24.png';
import { getFunctions, httpsCallable } from 'firebase/functions'; 
import LoadingModal from "./LoadingModal";

function GroupInviteLink({ groupId }) {
    const [qrCodeLink, setQrCodeLink] = useState("");
    const [invitationText, setInvitationText] = useState("");

    async function getInvitationLink(groupId, shareUrlToUse, expirationDateTime) {
        try {
            toggleModal("loadingModal");
            const functionsInstance = getFunctions();
            const generateOrRefreshCallable = httpsCallable(functionsInstance, 'generateOrRefreshInviteLink');
            const result = await generateOrRefreshCallable({ groupId: groupId });

            // Use the link and token from the function's response for sharing
            if (result.data && result.data.link && result.data.inviteToken) {
                shareUrlToUse = result.data.link;
                // Convert the timestamp in milliseconds to a human-readable time string with AM/PM
                const date = new Date(result.data.joinUntilTimestampMillis);
                expirationDateTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
            } else {
                console.warn("generateOrRefreshInviteLink did not return expected data, using fallback values for sharing.");
            }
        } catch (error) {
            console.error("Error calling generateOrRefreshInviteLink, using fallback values for sharing:", error);
            // shareUrlToUse and shareTokenToUse will remain the fallback values
        } finally {
            toggleModal("loadingModal");
        }

        return { shareUrlToUse, expirationDateTime };
    }

    const getQRCodeInvitation = async() => {
        var shareUrlToUse;
        var expirationDateTime;
        ({ shareUrlToUse, expirationDateTime } = await getInvitationLink(groupId, shareUrlToUse, expirationDateTime));
        setQrCodeLink(shareUrlToUse);
        setInvitationText(`This invitation link expires at ${expirationDateTime}`);
        toggleModal("modal-QRCode")
    }

    const handleMobileShare = async () => {
        var shareUrlToUse;
        var expirationDateTime;
        ({ shareUrlToUse, expirationDateTime } = await getInvitationLink(groupId, shareUrlToUse, expirationDateTime));

        navigator.share({
            title: 'Join my game group!',
            text: `Use the link to join my game group. This link is valid until ${expirationDateTime}`,
            url: shareUrlToUse
        });
    }

    return (
        <>
            <LoadingModal />
            <div className='box has-background-info-95 has-wrap-anywhere'>
                <div className="is-size-6 has-text-weight-semibold">
                    <span className="mr-3">Invite Link</span>
                    <span className={"mr-2 is-clickable " + (navigator.share ? "" : "is-hidden")} onClick={handleMobileShare}><Icon size={.8} path={mdiShareVariant} /></span>
                    <span className="is-clickable" onClick={() => { getQRCodeInvitation(); }}><Icon size={.8} path={mdiQrcode} /></span> <br />
                </div>

                <div id="modal-QRCode" className="modal">
                    <div className="modal-background"></div>
                    <div className="modal-card">
                        <header className="modal-card-head has-text-centered">
                            <p className="modal-card-title">Join Our Group</p>
                            <button className="delete" aria-label="close" onClick={() => {toggleModal('modal-QRCode') }}></button>
                        </header>
                        <section className="modal-card-body">
                            <div className="is-flex is-justify-content-center">
                                {/* QR Code still uses the original inviteLink */}
                                <QRCode
                                    value={qrCodeLink} 
                                    id="qrCodeLink" size={256} qrStyle="dots" bgColor='#34495e' fgColor='#FFF'
                                    logoImage={logo24}
                                    logoPadding={2}
                                    logoWidth={54}
                                    logoPaddingStyle='circle' />
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GroupInviteLink;
